import { render, staticRenderFns } from "./AffiliateForm.vue?vue&type=template&id=1e53cdfc&scoped=true&"
import script from "./AffiliateForm.vue?vue&type=script&lang=js&"
export * from "./AffiliateForm.vue?vue&type=script&lang=js&"
import style0 from "./AffiliateForm.vue?vue&type=style&index=0&id=1e53cdfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e53cdfc",
  null
  
)

export default component.exports